/* eslint-disable no-console */

import { Noti_getTopicName } from './Noti.getTopicName'
import { Plat_isCordova } from '../Plat/Plat.device'

export const Noti_subscribe = async () => {
    if (!Plat_isCordova()) return

    if (window.FCM == null) {
        console.warn('FCM failed to load')
        return
    }

    const wasPermissionGiven = await FCM.requestPushPermission()
    // Permission is needed on iOS and is only requested once,
    // next time it just returns false.
    // The user has then give permission manually in Settings,
    // we can hint it to them by displaying an alert(?)

    if (!wasPermissionGiven) {
        console.warn('Notification permissions not granted')
        // window.alert(
        //     'Please give Zaptic a permission to show notifications (look in Settings app -> Zaptic). ' +
        //         'A log out might be needed afterwards for notifications to work.'
        // )
    }

    const topic = await Noti_getTopicName()
    // Not sure if this subscription makes sense:
    // 1) if permission wasn't given
    // 2) if permission was given manually in Settings, then this code will be called only after a re-login
    //    - is it how it's supposed to work?
    // 3) I would think that an app should subscribe every time it's open, not only after a login
    //    (and currently Noti_subscribe is called only after login flow)
    await FCM.subscribeToTopic(topic)
}
